import { Link } from 'gatsby';
import styled from 'styled-components';

export const SSection = styled.section`
  background-color: transparent;
`;

export const SSectionTitle = styled.h5`
  margin-bottom: 25px;
`;

export const SCategoryItem = styled.div`
  display: flex;
  font-size: 13px;
  color: ${props => props.theme.colors.dark_grey};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.colors.light_grey};
  padding: 10px 0;
  &:first-of-type {
    padding-top: 0px;
  }
`;

export const SCategoryName = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.dark_grey};
`;

export const SCategoryTotalPosts = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.dark_grey};
`;

export const SAllLink = styled(Link)`
  font-size: 14px;
`;
